module.exports = __webpack_public_path__ + "static/img/gift.38f9c000.png";